import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";

class priorityForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <Select
                            {...this.props.getFieldProps("priority")}
                            objectValue={false}
                            name="priority"
                            optionname="priority_value"
                            storeType="local"
                            value={this.props.values.priority}
                            saveChanges={this.props.setFieldValue}
                            label="Kiemelés"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("start_date")}
                                isClearable={true}
                                maxDate={this.props.values.end_date}
                                name="start_date"
                                value={this.props.values.start_date}
                                label="Kezdés"
                                showTime={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("end_date")}
                                isClearable={true}
                                minDate={this.props.values.start_date}
                                name="end_date"
                                value={this.props.values.end_date}
                                label="Lejárat"
                                showTime={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            storeType="remote"
                            component="ComponentConfig"
                            objectValue={false}
                            valueKey="name"
                            labelKey="name"
                            name="option_type"
                            value={this.props.componentconfig.option_type}
                            label="Komponens"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("option_type")}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            name="option_id"
                            value={this.props.values.option_id}
                            label="Id"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("option_id")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(priorityForm);
